/** What the collapsed "Mənbə" row says: every site ("Bütün saytlar · 7")
 *  when none or all are picked, else the picked ones, two by name and the
 *  rest as a count ("bina.az, tap.az +1"). */
export function sourceSummary(
  picked: string[],
  sites: { id: string; label: string }[],
  allLabel: string,
): string {
  const on = sites.filter((s) => picked.includes(s.id));
  if (on.length === 0 || on.length === sites.length) return allLabel.replace("{n}", String(sites.length));
  const names = on.slice(0, 2).map((s) => s.label).join(", ");
  return on.length > 2 ? `${names} +${on.length - 2}` : names;
}
